import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import {Link, Redirect} from "react-router-dom"
import VerificaToken from '../../components/VerificaToken';
import RimozionePagamento from '../../components/RimozionePagamento';
import RimozionePatente from '../../components/RimozionePatente';
import ModalAggiungiPatente from '../../components/ModalAggiungiPatente';
import ModalAggiungiPagamento from '../../components/ModalAggiungiPagamento';
import RimozioneAccount from '../../components/RimozioneAccount';
import RubberBand from 'react-reveal/RubberBand';
import Zoom from "react-reveal/Zoom"

function Profilo() {


    const {user, setUser} = VerificaToken();


    return (
       
        <Container fluid>
            {user ? (
                <Container fluid>
<Container fluid id="banner_account" className="head-banner text-center text-white">
                <Row>
                    <Col>
                        <h1><strong>8-Bit Motors</strong></h1>
                    </Col>
                </Row>
        </Container>

        <RubberBand>
        <Container>
        
            <Row>
            
            
                
                        <h2 className="mb-3"><strong><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-lines-fill" viewBox="0 0 16 16">
                            <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"/>
                        </svg>    Informazioni Account</strong></h2>
                        <Col>
                            <Container className="container_account">
                                <h4 className="titolo_account"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-fill" viewBox="0 0 16 16">
                            <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                        </svg>   
                        
                        
                        Informazioni Personali</h4>
                                <ul>
                                    <li>
                                        <Col className="col-sm-6 elemento_lista">
                                        <h5>Nome:</h5>
                                        <p>{user.nome}</p>
                                        </Col>
                                    </li>
                                    <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>Cognome:</h5>
                                    <p>{user.cognome}</p>
                                    </Col>
                                    </li>
                                    <li>
                                        <Col className="col-sm-6 elemento_lista">
                                        <h5>Regione:</h5>
                                        <p>{user.regione}</p>
                                        </Col>
                                    </li>
                                    <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>Provincia:</h5>
                                    <p>{user.provincia}</p>
                                    </Col>
                                    </li>
                                    <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>Comune:</h5>
                                    <p>{user.comune}</p>
                                    </Col>
                                    </li>
                                    <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>Data Nascita:</h5>
                                    <p>{user.dataNascita.slice(0, 10)}</p>
                                    </Col>
                                    </li>
                                    <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>Indirizzo:</h5>
                                    <p>{user.indirizzo}</p>
                                    </Col>
                                    </li>
                                    <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>CAP:</h5>
                                    <p>{user.CAP}</p>
                                    </Col>
                                    </li>
                                    <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>Telefono:</h5>
                                    <p>{user.telefono}</p>
                                    </Col>
                                    </li>
                                </ul>
                            </Container>
                        </Col>

                        <Col>
                        {user.nomeIntestatario && (
                            <Container className="container container_account" >
                            <h4 className="titolo_account"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="icona_account bi bi-credit-card" viewBox="0 0 16 16">
                                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
                                <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
                            </svg>    Estremi di Fatturazione</h4>
                            <ul>
                                <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>Nome Intestatario:</h5>
                                    <p>{user.nomeIntestatario}</p>
                                    </Col>
                            </li>
                            <li>
                                    <Col className="col-sm-6 elemento_lista">
                                    <h5>Codice Carta:</h5>
                                    <p>{user.codiceCarta}</p>
                                    </Col>
                            </li>
                            <li>
                                <Col className="col-sm-6 elemento_lista">
                                <h5>Scadenza:</h5>
                                <p>{user.scadenzaCarta.slice(0, 10)}</p>
                                </Col>
                        </li>
                        <li>
                                <Col className="col-sm-6 elemento_lista">
                                    <h5>CVC:</h5>
                                    <p>{user.cvc}</p>
                                </Col>
                            </li>
                            </ul>
                        </Container>
                        )}
                            
                        </Col>
                </Row>
                <Row className="justify-content-md-center mb-5">
                    <Col className="col-lg-6">
                        {user.codicePatente && (
                            <Container className="container_account" >
                            <h4 className="titolo_account"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-credit-card-2-front-fill" viewBox="0 0 16 16">
                                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>
                            </svg> Informazioni Patente</h4>
                            <ul>
                                <li>
                                    <Col className="col-sm-6 elemento_lista">
                                        <h5>Nominativo:</h5>
                                        <p>{user.nominativo}</p>
                                    </Col>
                                </li>
                                <li>
                                    <Col className="col-sm-6 elemento_lista">
                                        <h5>Codice Patente:</h5>
                                        <p>{user.codicePatente}</p>
                                    </Col>
                                </li>
                                <li>
                                    <Col className="col-sm-6 elemento_lista">
                                        <h5>Scadenza:</h5>
                                        <p>{user.scadenzaPatente.slice(0, 10)}</p>
                                    </Col>
                                </li>
                                <li>
                                    <Col className="col-sm-6 elemento_lista">
                                        <h5>Data di Rilascio:</h5>
                                        <p>{user.dataRilascio.slice(0, 10)}</p>
                                    </Col>
                                </li>
                            </ul>
                    </Container>
                        )}
                </Col>
                </Row>
        </Container>
        </RubberBand>

        {/* SEZIONE MENU */}
        <Container fluid className="sezione-icone bg-light text-center">
        <Zoom>
                <Container>
                    <Row>
                    <Col>
                        <Link to={`/account/info/${user.id}/modificaPassword`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-badge" viewBox="0 0 16 16">
                            <path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                            <path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0h-7zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492V2.5z"/>
                        </svg>

                        <h3>Modifica Password</h3>
                        <p>Clicca qui per modificare la tua password.</p>
                        </Link>
                    </Col>

                    <Col>
                        <Link to={`/account/info/${user.id}/modificaInfoPersonali`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-plus" viewBox="0 0 16 16">
                                    <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                                    <path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                                    
                                  </svg>
                                  <h3>Modifica Account</h3>
                                  <p>Clicca qui per modificare le tue informazioni personali.</p>
                        </Link>
                        </Col>

                        <Col>
                        <ModalAggiungiPagamento/>
                        </Col>
                        
                        <Col>
                            <RimozionePagamento/>
                        </Col>

                        <Col>
                            <ModalAggiungiPatente/>
                        </Col>

                        <Col>
                            <RimozionePatente/>
                        </Col>

                        {user.tipo !== "Amministratore" && (
                            <Col>
                            <RimozioneAccount/>
                            </Col>
                        )}
                    </Row>
                </Container>
                </Zoom>
            </Container>
                </Container>
                
            ) : (
                <>
                    <Redirect to="/account/login" />
                </>
            )}



        </Container>
    )
}

export default Profilo
